(() => {
  const controllers = new WeakMap();
  function initialise(scope = document) {
    scope.querySelectorAll('[data-ms-vault][data-member="true"]').forEach(root => {
      if (controllers.has(root)) return;
      const dialog = root.querySelector('[data-vault-cinema]');
      const video = root.querySelector('[data-vault-film]');
      const contents = root.querySelector('[data-vault-contents]');
      const enterPane = root.querySelector('[data-vault-enter-pane]');
      const replay = root.querySelector('[data-vault-replay]');
      const caption = root.querySelector('[data-vault-caption]');
      const sound = root.querySelector('[data-vault-sound]');
      const soundLabel = root.querySelector('[data-vault-sound-label]');
      const skip = root.querySelector('[data-vault-skip]');
      const play = root.querySelector('[data-vault-play]');
      const progress = root.querySelector('[data-vault-progress]');
      const intro = root.querySelector('[data-vault-intro]');
      const status = root.querySelector('[data-vault-status]');
      const door = root.querySelector('.physical-door');
      if (!dialog || !video || !contents) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let destroyed = false;
      let ending = false;
      let active = false;
      let deadline;
      let finishTimer;
      let audible = !!window.MSSound?.enabled;
      let generation = 0;

      const phase = value => {
        root.classList.remove('phase-locked','phase-cinema','phase-open');
        root.classList.add('phase-' + value);
        const open = value !== 'locked';
        if (enterPane) enterPane.hidden = open;
        contents.hidden = !open;
        door?.setAttribute('aria-hidden', String(open));
        if (intro) intro.textContent = open ? intro.dataset.open : intro.dataset.locked;
        if (status) status.textContent = open ? status.dataset.granted : '';
      };
      const updateSound = () => {
        video.muted = !audible;
        sound?.setAttribute('aria-pressed', String(audible));
        sound?.setAttribute('aria-label', audible ? sound.dataset.mute : sound.dataset.enable);
        if (soundLabel) soundLabel.textContent = audible ? soundLabel.dataset.on : soundLabel.dataset.off;
        const soundOn = sound?.querySelector('[data-vault-sound-on]');
        const soundOff = sound?.querySelector('[data-vault-sound-off]');
        if (soundOn) soundOn.hidden = !audible;
        if (soundOff) soundOff.hidden = audible;
      };
      const complete = () => {
        clearTimeout(deadline);
        clearTimeout(finishTimer);
        video.pause();
        active = false;
        phase('open');
        if (dialog.open) {
          if (window.MSDialogs) window.MSDialogs.close(dialog); else dialog.close();
        }
        if (!destroyed) requestAnimationFrame(() => {
          contents.focus({ preventScroll:true });
          contents.scrollIntoView({ block:'start', behavior:'instant' });
        });
      };
      const finish = () => {
        if (ending || !active) return;
        ending = true;
        generation++;
        clearTimeout(deadline);
        video.pause();
        dialog.classList.add('is-leaving');
        finishTimer = setTimeout(complete, motion.matches ? 0 : 650);
      };
      const begin = async () => {
        if (active || destroyed) return;
        active = true;
        ending = false;
        const attempt = ++generation;
        if (motion.matches) { complete(); return; }
        phase('cinema');
        dialog.classList.remove('is-leaving');
        const mobile = matchMedia('(max-width:700px)').matches;
        video.poster = mobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        video.src = mobile ? video.dataset.mobile : video.dataset.desktop;
        video.volume = .65;
        audible = !!window.MSSound?.enabled;
        updateSound();
        if (caption) caption.textContent = caption.dataset.waiting;
        if (play) play.hidden = true;
        if (progress) progress.style.transform = 'scaleX(0)';
        if (window.MSDialogs) window.MSDialogs.open(dialog); else dialog.showModal();
        skip?.focus({ preventScroll:true });
        deadline = setTimeout(finish, 30000);
        try { await video.play(); }
        catch {
          if (destroyed || ending || generation !== attempt) return;
          audible = false;
          updateSound();
          try { await video.play(); }
          catch { if (!destroyed && !ending && generation === attempt && play) play.hidden = false; }
        }
      };
      const timeUpdate = () => {
        const fraction = Number.isFinite(video.duration) && video.duration > 0 ? video.currentTime / video.duration : 0;
        if (progress) progress.style.transform = `scaleX(${fraction})`;
        if (caption) caption.textContent = fraction >= .77 ? caption.dataset.chapterThree : fraction >= .3 ? caption.dataset.chapterTwo : caption.dataset.chapterOne;
      };
      root.querySelector('[data-vault-enter]')?.addEventListener('click', begin);
      replay?.addEventListener('click', begin);
      skip?.addEventListener('click', finish);
      sound?.addEventListener('click', () => {
        audible = !audible;
        updateSound();
        if (video.paused) void video.play().catch(() => { audible = false; updateSound(); if (play) play.hidden = false; });
      });
      play?.addEventListener('click', () => { void video.play().catch(finish); });
      video.addEventListener('timeupdate', timeUpdate);
      video.addEventListener('playing', () => { if (play) play.hidden = true; timeUpdate(); });
      video.addEventListener('ended', finish);
      video.addEventListener('error', finish);
      dialog.addEventListener('cancel', event => { event.preventDefault(); finish(); });
      dialog.addEventListener('close', () => { if (active) { ending = true; generation++; complete(); } });
      const motionChanged = () => { if (replay) replay.hidden = motion.matches; if (motion.matches && active) finish(); };
      motion.addEventListener('change', motionChanged);
      phase('locked');
      motionChanged();
      controllers.set(root, () => {
        destroyed = true;
        generation++;
        clearTimeout(deadline);
        clearTimeout(finishTimer);
        motion.removeEventListener('change', motionChanged);
        video.pause();
        active = false;
        if (dialog.open) { if (window.MSDialogs) window.MSDialogs.close(dialog); else dialog.close(); }
        video.removeAttribute('src');
        video.load();
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ms-vault]').forEach(root => controllers.get(root)?.()));
})();
